import { Component, Input } from "@angular/core";
import { CebeViewModel } from "src/app/_core/models/centros/cebe.model";

/**
 * ⚠️ DESCONECTADO (ui-redesign, 2026-06-03).
 * El mapa de centros basado en Leaflet (@asymmetrik/ngx-leaflet) se retira como
 * parte del rediseño; se reconstruirá con MapLibre + clustering, funcionalmente
 * equivalente (hover, click, popup de detalle, filtros, zoom). Ver
 * docs/ui-redesign/05-map-redesign.md.
 *
 * Se conserva el contrato de @Input (cebeId, cebe, loadByCebe) para que los
 * consumidores (p. ej. cebes/detail) sigan compilando sin cambios.
 */
@Component({
    selector: "app-mini-map",
    templateUrl: "./mini-map.component.html",
    styleUrls: ["./mini-map.component.scss"],
    standalone: false
})
export class MiniMapComponent {
	@Input() cebeId: any;
	@Input() cebe: CebeViewModel;
	@Input() loadByCebe = false;
}
